import React, { Suspense } from "react";
import { RouteObject } from "react-router-dom";
import Error from "../../../Components/UI-KIT/Error";
import RoutesPaths from "../../routePath";
import { NotFoundPage } from "../../../Pages/NotFound.page";
import { MainPage } from "../../../Pages/Main.page";
import OtherRoutesPaths from "../other.route/other.routesPaths";
import CheckAuth from "../../services/Components/CheckAuth";
import CabinetRoutesPaths from "./cabinet.routesPaths";
import MainLayout from "src/user.InterfaceLayer/Layouts/Main.layout";
import { EventsPage } from "../../../Pages/Events.page";
import { TestPage } from "../../../Pages/Test.page";
import { TestsPage } from "../../../Pages/Tests.page";
import { TestResultPage } from "../../../Pages/TestResult.page";
import { AssociationPage } from "../../../Pages/Association.page";
import { NotificationsPage } from "../../../Pages/Notifications.page";
import { EditProfilePage } from "../../../Pages/EditProfile.page"; //старый профиль
import { LoyaltyProgramPage } from "../../../Pages/loyaltyProgramPage.page";
import { MaterialsPage } from "src/old/Pages/Materials";
import { MaterialPage } from "src/old/Pages/Material";

const cabinetRoutes: RouteObject[] = [
	{
		path: RoutesPaths.CABINET,
		errorElement: <Error />,
		children: [
			{
				element: <CheckAuth />,
				errorElement: <Error />,
				children: [
					{
						element: <MainLayout />,
						errorElement: <Error />,
						children: [
							{
								index: true,
								path: CabinetRoutesPaths.MAIN,
								element: (
									<Suspense>
										<MainPage />
									</Suspense>
								),
								errorElement: <Error />,
							},
							{
								index: true,
								path: CabinetRoutesPaths.EVENTS,
								element: (
									<Suspense>
										<EventsPage />
									</Suspense>
								),
								errorElement: <Error />,
							},
							{
								index: true,
								path: CabinetRoutesPaths.MATERIALS,
								element: (
									<Suspense>
										<MaterialsPage />
									</Suspense>
								),
								errorElement: <Error />,
							},
							{
								index: true,
								path: CabinetRoutesPaths.MATERIALS + "/:id",
								element: (
									<Suspense>
										<MaterialPage />
									</Suspense>
								),
								errorElement: <Error />,
							},
							{
								index: true,
								path: CabinetRoutesPaths.LOYALTY_PROGRAM,
								element: (
									<Suspense>
										<LoyaltyProgramPage />
									</Suspense>
								),
								errorElement: <Error />,
							},
							{
								index: true,
								path: CabinetRoutesPaths.TESTS,
								element: (
									<Suspense>
										<TestsPage />
									</Suspense>
								),
								errorElement: <Error />,
							},
							{
								index: true,
								path: CabinetRoutesPaths.TEST + "/:id",
								element: (
									<Suspense>
										<TestPage />
									</Suspense>
								),
								errorElement: <Error />,
							},
							{
								index: true,
								path: CabinetRoutesPaths.TEST_RESULT + "/:id",
								element: (
									<Suspense>
										<TestResultPage />
									</Suspense>
								),
								errorElement: <Error />,
							},
							{
								index: true,
								path: CabinetRoutesPaths.ASSOCIATION,
								element: (
									<Suspense>
										<AssociationPage />
									</Suspense>
								),
								errorElement: <Error />,
							},
							{
								index: true,
								path: CabinetRoutesPaths.EDIT_PROFILE,
								element: (
									<Suspense>
										<EditProfilePage />
									</Suspense>
								),
								errorElement: <Error />,
							},
							{
								index: true,
								path: CabinetRoutesPaths.NOTIFICATION,
								element: (
									<Suspense>
										<NotificationsPage />
									</Suspense>
								),
								errorElement: <Error />,
							},
							{
								path: OtherRoutesPaths.NOT_FOUND,
								element: (
									<Suspense>
										<NotFoundPage />
									</Suspense>
								),
								errorElement: <Error />,
							},
						],
					},
				],
			},
		],
	},
];

export default cabinetRoutes;
